export const SCHEDULE_DEACTIVATE = 'user/SCHEDULE_DEACTIVATE';

export const CANCEL_DEACTIVATE = 'user/CANCEL_DEACTIVATE';

export const DEACTIVATE_START = 'user/DEACTIVATE_START';

export const DEACTIVATE_SUCCESS = 'user/DEACTIVATE_SUCCESS';

export const DEACTIVATE_FAILUTE = 'user/DEACTIVATE_FAILUTE';
